const twareasData = []
const countryData = [{ ID: 4, Name: 'Taiwan, China' }]
const provinceData = [{ Country: 4, ID: 27, Name: 'Taiwan Province' }]
const cityData = [
  { Province: 27, ID: 316, Name: 'Taipei City' },
  { Province: 27, ID: 317, Name: 'Kaohsiung City' },
  { Province: 27, ID: 318, Name: 'Tainan City' },
  { Province: 27, ID: 319, Name: 'Taichung City' },
  { Province: 27, ID: 320, Name: 'Kinmen County' },
  { Province: 27, ID: 321, Name: 'Nantou County' },
  { Province: 27, ID: 322, Name: 'Keelung City' },
  { Province: 27, ID: 323, Name: 'Hsinchu City' },
  { Province: 27, ID: 324, Name: 'Chiayi City' },
  { Province: 27, ID: 325, Name: 'New Taipei City' },
  { Province: 27, ID: 326, Name: 'Yilan County' },
  { Province: 27, ID: 327, Name: 'Hsinchu County' },
  { Province: 27, ID: 328, Name: 'Taoyuan County' },
  { Province: 27, ID: 329, Name: 'Miaoli County' },
  { Province: 27, ID: 330, Name: 'Changhua County' },
  { Province: 27, ID: 331, Name: 'Changhua County' },
  { Province: 27, ID: 332, Name: 'Yunlin County' },
  { Province: 27, ID: 333, Name: 'Pingtung County' },
  { Province: 27, ID: 334, Name: 'Taitung County' },
  { Province: 27, ID: 335, Name: 'Hualien County' },
  { Province: 27, ID: 336, Name: 'Penghu County' },
]
//仅省市选择
for (const provinceItem of provinceData) {
  twareasData.push({
    value: provinceItem.ID, // 省份code值
    label: provinceItem.Name, // 省份汉字
    children: [],
  })
}

for (const provinceItem of twareasData) {
  for (const cityItem of cityData) {
    if (cityItem.Province === provinceItem.value) {
      provinceItem.children.push({
        value: cityItem.ID,
        label: cityItem.Name,
      })
    }
  }
}
export default twareasData



// WEBPACK FOOTER //
// ./src/utils/twareasen.js